import { NavigateRoutes } from 'common/constants/app.constant';
import { BaseDataModel, FormMetaModel } from '../../utilitymodels/base.model';

export class OpportuinityItem {
    name: string;
    img: string;
    url: string;
}

export class OpportunityModel extends BaseDataModel {}

export class OpportunityMetaModel extends FormMetaModel {
    constructor() {
        super('Opportunities', '', false, NavigateRoutes.distributordashboard);
    }

    OpportuinityInfo: OpportuinityItem[] = [
        {
            name: 'SIP Opportunities',
            img: 'assets/images/opportunities/SIP-opportunities.svg',
            url: NavigateRoutes.sipOpportunity,
        },
        {
            name: 'CROSS SELL OPPORTUNITIES',
            img: 'assets/images/opportunities/cross-sell-opportunities.svg',
            url: NavigateRoutes.crossSellOpportunity,
        },
        {
            name: 'ACTIVATION OPPORTUNITIES',
            img: 'assets/images/opportunities/activation-opportunities.svg',
            url: NavigateRoutes.activationOpportunity,
        },
        {
            name: 'OTHER OPPORTUNITIES',
            img: 'assets/images/opportunities/other-opportunities.svg',
            url: NavigateRoutes.otherOpportunity,
        },
    ];

    initProperties() {
        return {
            OpportuinityInfo: this.OpportuinityInfo,
        };
    }
}
